






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  name: 'CustomOverlayPanel',
})
class CustomOverlayPanel extends Vue {
  @Prop({ default: 0, required: true, type: Number }) public filterCounter!: number

  isPopoverOpen = false
  localKeyword = ''
  appliedFilterCount = 0

  created(): void {
    this.appliedFilterCount = this.filterCounter
  }

  mounted(): void {
    if (typeof window !== 'undefined') {
      document.addEventListener('click', this.handleClickOutside)
    }
  }

  beforeDestroy(): void {
    if (typeof window !== 'undefined') {
      document.removeEventListener('click', this.handleClickOutside)
    }
  }

  private handleClickOutside(event: MouseEvent): void {
    if (!this.isPopoverOpen) return
    const target = event.target as Node
    if (this.$el && !this.$el.contains(target)) {
      this.closePopover()
    }
  }

  togglePopover(): void {
    if (this.isPopoverOpen) {
      this.closePopover()
    } else {
      this.isPopoverOpen = true
      this.$emit('open')
    }
  }

  closePopover(): void {
    if (!this.isPopoverOpen) return
    this.isPopoverOpen = false
    this.$emit('cancel')
  }

  handleReset(): void {
    this.appliedFilterCount = 0
    this.isPopoverOpen = false
    this.$emit('reset')
  }

  handleApply(): void {
    this.appliedFilterCount = this.filterCounter
    this.isPopoverOpen = false
    this.$emit('apply')
  }

  @Watch('filterCounter')
  onChangeFilterCounter(val: number): void {
    if (val === 0) {
      this.appliedFilterCount = 0
    }
  }
}

export default CustomOverlayPanel
